






































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Tree, Progress } from "element-ui";
import { ruleNormal, rulePattern, hasPermission } from "../../../utils/common";
import {
  getAllOrgTreeList,
  getAllOrgLevelList,
  getOrgByOrgId,
  postBaseOrg,
  putBaseOrgByOrgId,
  delBaseOrgByOrgId,
  getPageByOrgId,
  postBaseUserByOrgId,
  putBaseUserById,
  delBaseUserByIds,
  queryAllUserTypes
} from "../../../api/usersManage";
Vue.use(hasPermission);

interface searchForm {
  current: number | undefined;
  isChecked: boolean | string | undefined | null;
  size: number | undefined;
  userNameOrAccount: string | undefined;
}
interface userOrgInfo {
  orgCode: undefined;
  orgName: undefined;
  orgLevel: string | undefined;
  orgOrder: undefined;
  isEnable: string;
  orgParentId: string;
  orgDescription: string | undefined;
}

interface usertableInfo {
  userName: string | undefined;
  userAccount: string | undefined;
  userMobile: string | undefined;
  userDescription: string | undefined;
  deleted: string | undefined; // 后台返回的是字符串 "N"
  remark: string | undefined;
  userPassword: string | undefined;
  checkPass: string | undefined;
  userId: string;
  orgName: string;
  userType: string;
  // 后台返回的是字符串 "TRUE"
  isEnable: string | undefined;
  enabled: string | undefined;
  accountNonExpired: string | undefined;
  credentialsNonExpired: string | undefined;
  accountNonLocked: string | undefined;
}
@Component({
  name: "userManage",
  filters: {
    //  过滤器
    filterDeleOrNot(v) {
      let map = {
        Y: "已删除",
        N: "未删除"
      };
      return map[v];
    },
    filterEnableOrNot(v) {
      let map = {
        TRUE: "有效",
        FALSE: "无效"
      };
      return map[v];
    },
    filterAccountIsExpired(v) {
      let map = {
        TRUE: "未过期",
        FALSE: "已过期"
      };
      return map[v];
    },
    filterCredentialIsExpired(v) {
      let map = {
        TRUE: "未过期",
        FALSE: "已过期"
      };
      return map[v];
    },
    filterLockOrUnlock(v) {
      let map = {
        TRUE: "已锁定",
        FALSE: "未锁定"
      };
      return map[v];
    },
    filterIsEnable(v) {
      let map = {
        TRUE: "可用",
        FALSE: "不可用"
      };
      return map[v];
    },
    filterHasRemark(v) {
      let map = {
        null: "暂无备注"
        // "N": "未锁定"
      };
      return map[v];
    },
    filterIsSwitch(v) {
      let map = {
        Y: "是",
        N: "否"
      };
      return map[v];
    }
  }
})
export default class usersManage extends Vue {
  // 用户机构树的数据
  private userResourceTree: Array<object> = [];
  private chkedArr: Array<object> = []; // 默认选中的节点的数组
  private userTypeList: Array<object> = [];
  private defaultProps: Object = {
    children: "childList",
    label: "name"
  };
  private resTreeLoading:boolean = false // tree loading
  private userOrgId: string = ""; // 全局orgId
  private userOrgParentId: string = ""; // 全局orgParentId
  private superManagerId: string = ""; // 超级管理员的id
  private isNotRootOrg: boolean = true; // 不是根节点就是true
  private userOrgIsChecked: any;

  private filterText: string = "";
  private orgOperateType: string = "";
  private orgOperateVisible: boolean = false;
  private addLoading: boolean = false;
  private dialogResetFlag: boolean = false;
  // 用来解决浏览器自动填充表单密码和账号 其实也可以不添加
  private ceshipassword: object = {};

  private userOrgForm: userOrgInfo = {
    orgCode: undefined,
    orgName: undefined,
    orgLevel: undefined,
    orgOrder: undefined,
    isEnable: "true",
    orgParentId: "",
    orgDescription: undefined
  };

  created() {
    this.getUserTypes();
  }

  //获取所有应用类型
  private async getUserTypes() {
    let result = await queryAllUserTypes();
    this.userTypeList = result.data;
  }

  private orgRules: object = {
    orgCode: [rulePattern(/^[^\u4e00-\u9fa5]+$/, "请输入非中文的参数编码")],
    orgName: [ruleNormal("请输入参数名称")],
    orgLevel: [ruleNormal("请输入层级值")],
    isEnable: [ruleNormal("请选择是否可用")],
    orgOrder: [rulePattern(/^(|[0-9]+)$/, "请输入整数")]
  };

  private arrLength: number = 0; // 定义一个全局的数组长度，用来做左侧tree菜单是否有子元素的判断
  // 右侧 用户表格的数据
  private baseUserTableData: Array<object> = [];
  private userBaseVisible: boolean = false;
  private baseUserTableLoading: boolean = false;
  private total: number = 0;
  private size: number = 10;
  private current: number = 1;

  // 右键增加修改要用到的根据父级id所获取的父级name，这个id用
  private idForParentName: string = "";
  private parentNameForShow: string = "";
  // 表格弹出框用到的数据
  private userId: string = "";
  private tableOperateType: string = "";
  private tableOperateVisible: boolean = false;
  private tableDialogResetFlag: boolean = false;
  private tableFormInfo: usertableInfo = {
    userName: undefined,
    userAccount: undefined,
    userMobile: "",
    userDescription: undefined,
    remark: undefined,
    userPassword: "",
    checkPass: "",
    userId: "",
    orgName: "",
    userType: "",
    isEnable: "",
    deleted: "",
    enabled: "",
    accountNonExpired: "TRUE", // 账号是否未过期
    credentialsNonExpired: "TRUE", // 密码是否未过期
    accountNonLocked: ""
  };
  private searchForm: searchForm = {
    current: this.current,
    isChecked: "TRUE",
    size: this.size,
    userNameOrAccount: ""
  };

  private tableFormInfoRules: object = {
    userAccount: [ruleNormal("请输入用户账户名")],
    userName: [ruleNormal("请输入用户姓名")],
    userMobile: [
      ruleNormal("请输入用户手机号"),
      rulePattern(/^1[3456789]\d{9}$/, "请输入正确的手机号码")
    ],
    enabled: [ruleNormal("请选择用户是否有效")],
    accountNonLocked: [ruleNormal("请选择是否锁定")],
    isEnable: [ruleNormal("请选择用户是否可用")],
    userPassword: [
      ruleNormal("请输入用户密码"),
      rulePattern(
        /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/,
        "密码为8-30个字符，必须包含数字、字母及符号"
      )
    ]
  };

  // "密码中必须包含字母、数字、特殊字符，至少8个字符，最多30个字符"
  public $refs!: {
    validate: HTMLFormElement;
    Resourcetree: HTMLFormElement;
    pass: HTMLFormElement;
  };

  //新增，查看，编辑操作赋值
  private operate(type: string, data?: userOrgInfo) {
    this.orgOperateVisible = true;
    this.orgOperateType = type;
    this.userOrgForm = {
      orgCode: type == "ADD" ? undefined : data!.orgCode,
      orgName: type == "ADD" ? undefined : data!.orgName,
      orgLevel: type == "ADD" ? undefined : data!.orgLevel,
      orgOrder: type == "ADD" ? undefined : data!.orgOrder,
      isEnable: type == "ADD" ? "true" : data!.isEnable,
      orgDescription: type == "ADD" ? "" : data!.orgDescription,
      orgParentId: this.userOrgParentId
    };
  }

  private validatePass2 = (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.tableFormInfo.userPassword) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };
  private pwdPass: boolean = false;

  private checkPassBlur(val) {
    if (this.noNeedPwdFlag) {
      return false;
    }
    if (!val) {
      this.$message.warning("请再次输入密码");
      return false;
    }
    if (val !== this.tableFormInfo.userPassword) {
      this.$message.error("两次密码输入不一致");
    }
  }

  /*----------------------左侧机构树---------------------*/
  private async getgetAllOrgTreeList() {
    let res = await getAllOrgTreeList();
    this.userResourceTree = res.data;
    this.userOrgId = res.data[0].id; // 页面刷新时默认加载的userOrgId
  }

  private async handleNodeClick(data) {
    this.resTreeLoading = true 
    data.parentId == "-1" ? (this.superManagerId = data.id) : "";
    this.idForParentName = data.parentId;
    this.userOrgParentId = data.id;
    this.userOrgIsChecked = data.isChecked;
    data.childList == null
      ? (this.arrLength = 0)
      : (this.arrLength = data.childList.length);
    this.userOrgId = data.id;
    this.getTableList();
    this.userBaseVisible = false; // 当点击树形组件的时候，隐藏右键菜单
    // 加多一个存储 父节点 名字
    // this.parentNameForShow = data.name
    this.resTreeLoading = false
  }

  // 节流函数
  private throttle(fn:Function, gapTime:Number) {
  let _lastTime:Number = 0;
  return function () {
    let _nowTime:Number = + new Date()
    if (Number(_nowTime) - Number(_lastTime) > gapTime || !_lastTime) {
      fn();
      _lastTime = _nowTime
    }
  }
}

private checkChange = this.throttle(this.handleChange,500)

private handleChange(obj){
  this.$refs.Resourcetree.setCheckedKeys([this.userOrgId]);
}

  //  关闭右键菜单的外面大盒子的事件
  private closeContextMenu(event) {
    let userBaseMenu = document.querySelector("#userBaseMenu");
    if (userBaseMenu) {
      if (!userBaseMenu.contains(event.target)) {
        this.userBaseVisible = false;
      }
    }
  }

  // 用户管理 》》 机构管理 》右键 ，
  private baseRightClick(event, object, value, element) {
    this.userBaseVisible = true;
    let userBaseMenu: any = document.querySelector("#userBaseMenu");
    userBaseMenu.style.zIndex = "9";
    userBaseMenu.style.left = event.clientX - event.offsetX + 70 + "px";
    userBaseMenu.style.top = event.clientY - event.offsetY + 10 + "px";
    this.idForParentName = object.parentId; // name专用id
    this.userOrgId = object.id;
    // this.userOrgParentId = object.parentId;
    this.userOrgParentId = object.id;
    object.parentId == "-1"
      ? (this.isNotRootOrg = false)
      : (this.isNotRootOrg = true);
  }

  // 增加机构
  private async addBaseMenu() {
    try {
      this.addLoading = false;
      this.orgOperateVisible = true;
      this.userBaseVisible = false;
      this.userOrgForm.orgParentId = this.userOrgParentId;

      let res = await getOrgByOrgId(this.idForParentName);
      this.parentNameForShow = res.data.orgName;
      this.orgOperateType = "ADD";
      this.operate("ADD", this.userOrgForm);
    } catch (error) {
      this.$message.error(error || "获取数据失败！");
    }
  }

  // 修改机构
  private async alterBaseMenu() {
    try {
      this.orgOperateVisible = true;
      this.userBaseVisible = false;
      this.orgOperateType = "EDIT";

      let res1 = await getOrgByOrgId(this.idForParentName);
      this.parentNameForShow = res1.data.orgName;

      let res = await getOrgByOrgId(this.userOrgId);
      this.operate("EDIT", { ...res.data });
    } catch (error) {
      this.$message.error(error || "修改失败！");
    }
  }

  //  机构的新增 和编辑
  private async handleSubmit() {
    let flag = false;
    this.$refs[`userOrgForm`].validate(valid => {
      valid && (flag = true);
    });
    if (!flag) return;
    this.addLoading = true;
    try {
      if (this.orgOperateType == "ADD") {
        await postBaseOrg(this.userOrgForm);
      } else {
        await putBaseOrgByOrgId(this.userOrgId, this.userOrgForm);
      }
      this.$message({
        type: "success",
        message: this.orgOperateType == "ADD" ? "新增成功" : "编辑成功"
      });
      this.addLoading = false;
      this.orgOperateVisible = false;
      this.getgetAllOrgTreeList();
    } catch (err) {
      this.$message.error(
        err || (this.orgOperateType == "ADD" ? "新增失败" : "编辑失败")
      );
    }
  }

  private dialogReset() {
    this.orgOperateVisible = false;
    this.dialogResetFlag = true;
    this.$nextTick(() => {
      this.dialogResetFlag = false;
    });
  }

  // 删除机构
  private async delBaseOrg(done) {
    if (this.userOrgParentId == "-1") {
      this.$message.warning("不能删除超级管理员呀");
      this.userBaseVisible = false;
      return false;
    }
    this.userBaseVisible = false;
    let confirm: boolean = false;
    this.arrLength > 0
      ? await this.$confirm(
          "此操作将永久删除该机构及其所有子机构, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          })
      : await this.$confirm("此操作将永久删除该机构, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          });
    if (!confirm) return;
    try {
      delBaseOrgByOrgId(this.userOrgId);
      this.$message({
        type: "success",
        message: "删除成功!"
      });
      this.getgetAllOrgTreeList(); // 不知道为什么这个刷新不了
    } catch (error) {
      this.$message({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 节点筛选
  @Watch("filterText", { deep: true })
  getfilterText(val, userResourceTree) {
    this.$refs.Resourcetree.filter(val);
    // 如果有上面的 $refs!声明，就用上面行，如果没有，就用下面这两行
    // const tree = <Tree>this.$refs.Resourcetree;
    // tree.filter(val);
  }

  private filterNode(value, userResourceTree) {
    if (!value) return true;
    return userResourceTree.name.indexOf(value) !== -1;
  }

  // 用户管理
  private tableSelectionId: Array<string> = []; //表格选中的数据id集合
  private handleSelectionChange(selection) {
    this.tableSelectionId = selection.reduce((arr, curVal) => {
      arr.push(curVal.userId);
      return arr;
    }, []);
  }

  //获取参数配置分页列表
  private async getTableList() {
    this.baseUserTableLoading = true;
    try {
      let result = await getPageByOrgId(this.userOrgId, this.searchForm);
      this.baseUserTableData = result.data.records;
      this.total = result.data.total;
      this.size = result.data.size;
      this.baseUserTableLoading = false;
    } catch (error) {
      this.baseUserTableLoading = false;
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 表格 行内查看
  private noNeedPwdFlag: boolean = false; // false就是需要两个面验证

  private async handleTableClick(type: string, data: usertableInfo) {
    this.noNeedPwdFlag = true;

    this.tableOperateVisible = true;
    this.tableOperateType = type;
    this.userId = data.userId;
    this.tableFormInfo = { ...data };
    // let res1 = await getOrgByOrgId(this.idForParentName);
    let res1: any;
    if (this.idForParentName == "-1") {
      res1 = await getOrgByOrgId(this.userOrgParentId);
    } else {
      res1 = await getOrgByOrgId(this.idForParentName);
    }
    this.parentNameForShow = res1.data.orgName;
  }
  // 清空表单
  private handleResetUserForm() {
    this.tableFormInfo = {
      userName: undefined,
      userAccount: undefined,
      userMobile: "",
      userDescription: undefined,
      remark: undefined,
      userPassword: "",
      checkPass: "",
      userId: "",
      orgName: "",
      userType: "",
      deleted: "",
      isEnable: "TRUE",

      enabled: "TRUE",
      accountNonExpired: "TRUE",
      credentialsNonExpired: "TRUE",
      accountNonLocked: "TRUE"
    };
  }
  // 增加按钮
  private async addUsers() {
    let checkKeys = this.$refs.Resourcetree.getCurrentKey();
    if (!checkKeys) {
      this.$message.warning("请选择一个节点！");
      return false;
    } else {
      this.userOrgId = checkKeys;
      this.tableOperateType = "ADD";
      let res1: any;
      if (this.idForParentName == "-1") {
        res1 = await getOrgByOrgId(this.userOrgParentId);
      } else {
        res1 = await getOrgByOrgId(this.idForParentName);
      }
      // let res1 = await getOrgByOrgId(this.idForParentName);
      this.parentNameForShow = res1.data.orgName;
      this.handleResetUserForm();
      this.tableOperateVisible = true;
    }
  }
  // 删除 批量删除
  private delUsers() {
    try {
      if (this.tableSelectionId.length == 0) {
        this.$message.warning("请先选择要删除的用户");
        return false;
      } else {
        this.tableSelectionId.forEach((v, i) => {
          if (v == this.superManagerId) {
            this.$message.warning("您选中了超级管理员，不能删除超级管理员！！");
          } else {
            this.$confirm("此操作将永久删除，是否继续？", "删除提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(async () => {
              await delBaseUserByIds(this.tableSelectionId);
              this.$message.success("删除成功");
              this.getTableList();
            });
          }
        });
      }
    } catch (error) {
      this.$message.error("删除失败！");
    }
  }

  // private noReg:boolean=false;
  private async handleTableSubmit() {
    let flag = false;
    this.$refs[`tableFormInfo`].validate(valid => {
      valid && (flag = true);
    });
    if (!flag) return;
    this.addLoading = true;
    try {
      if (this.tableOperateType == "ADD") {
        this.noNeedPwdFlag = false;
        this.tableFormInfo.deleted = "";
        let res = await postBaseUserByOrgId(this.userOrgId, this.tableFormInfo);
      } else {
        this.noNeedPwdFlag = true;
        // this.tableFormInfo.checkPass = this.tableFormInfo.userPassword = "";
        this.tableFormInfo.checkPass = this.tableFormInfo.userPassword;
        this.tableFormInfo.deleted = "";
        let res = await putBaseUserById(this.userId, this.tableFormInfo);
      }
      this.$message({
        type: "success",
        message: this.tableOperateType == "ADD" ? "新增成功" : "编辑成功"
      });
      this.addLoading = false;
      this.tableOperateVisible = false;
      this.getTableList();
    } catch (err) {
      this.$message.error(err);
    }
  }

  private tableDialogReset() {
    this.tableOperateVisible = false;
    this.tableDialogResetFlag = true;
    this.$nextTick(() => {
      this.tableDialogResetFlag = false;
    });
  }
  private handleSizeChange(val) {
    this.size = val;
    this.searchForm.size = val;
    this.getTableList();
  }
  private handleCurrentChange(val) {
    this.current = val;
    this.searchForm.current = val;
    this.getTableList();
  }
  //搜索重置
  private handleResetSearch() {
    this.searchForm = {
      current: 1,
      size: this.size,
      isChecked: undefined,
      userNameOrAccount: undefined
    };
    this.getTableList();
  }
  // 特意加一个方法，改bug，避免其他bug
  private async userManageInit() {
    try {
      let res = await getAllOrgTreeList();
      this.userResourceTree = res.data;
      this.userOrgId = res.data[0].id;
      let result = await getPageByOrgId(this.userOrgId, this.searchForm);
      this.baseUserTableData = result.data.records;
      this.total = result.data.total;
      this.size = result.data.size;
    } catch (error) {
      this.$message.error(error || "获取数据失败！");
    }
  }

  mounted() {
    this.userManageInit();
  }

  //改写tree组件开始
  private async treeAppend(data) {
    try {
      this.addLoading = false;
      this.orgOperateVisible = true;
      this.userBaseVisible = false;
      // 也可以写成data.id,因为是增加
      this.userOrgForm.orgParentId = this.userOrgParentId;
      let res = await getOrgByOrgId(this.idForParentName);
      this.parentNameForShow = res.data.orgName;
      this.orgOperateType = "ADD";
      this.operate("ADD", this.userOrgForm);
    } catch (error) {
      this.$message.error(error || "新增失败！");
    }
  }

  private async treeEdit(data) {
    try {
      this.orgOperateVisible = true;
      this.userBaseVisible = false;
      this.orgOperateType = "EDIT";
      let res1 = await getOrgByOrgId(this.idForParentName);
      this.parentNameForShow = res1.data.orgName;
      let res = await getOrgByOrgId(this.userOrgId);
      this.operate("EDIT", { ...res.data });
    } catch (error) {
      this.$message.error(error || "编辑失败！");
    }
  }

  private async treeDel(data) {
    if (this.userOrgParentId == "-1") {
      this.$message.warning("不能删除超级管理员呀");
      this.userBaseVisible = false;
      return false;
    }
    this.userBaseVisible = false;
    let confirm: boolean = false;
    this.arrLength > 0
      ? await this.$confirm(
          "此操作将永久删除该机构及其所有子机构, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          })
      : await this.$confirm("此操作将永久删除该机构, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          });
    if (!confirm) return;
    try {
      delBaseOrgByOrgId(this.userOrgId);
      this.$message({
        type: "success",
        message: "删除成功!"
      });
      this.getgetAllOrgTreeList(); // 不知道为什么这个刷新不了
    } catch (error) {
      this.$message({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private mouseleave(data, $event) {
    this.$set(data, "dis", false);
  }

  private mouseover(data, $event) {
    this.$set(data, "dis", true); // 动态每一项添加显示隐藏的标志
    this.userId = data.id; // 方便右侧点击使用
    this.userOrgParentId = data.id;
    this.userOrgId = data.id;
    // this.idForParentName = data.parentId; // name专用id
    this.idForParentName = data.parentId !== '-1' ? data.parentId : data.id // 解决-1 的问题
    data.childList == null
      ? (this.arrLength = 0)
      : (this.arrLength = data.childList.length);
  }
  //改写tree组件结束
}
